import {
    mdiAlert,
    mdiBike,
    mdiBus,
    mdiChevronRight,
    mdiChevronDown,
    mdiClose,
    mdiDirections,
    mdiMagnify,
    mdiMapMarker,
    mdiPhone,
    mdiStar,
    mdiStarOutline,
    mdiSteering, mdiTicket,
    mdiTram,
    mdiTransitConnection,
    mdiWalk, mdiFacebook, mdiTwitter, mdiEmail, mdiTrain, mdiChevronLeft,
    mdiHomeSiloOutline, mdiHomeCircle, mdiBusMultiple, mdiBusSchool, mdiTarget,
} from "@mdi/js";

export const LEG_MODE_WALK = 'walk';
export const LEG_MODE_BUS = 'bus';
export const LEG_MODE_TRAM = 'tram';
export const LEG_MODE_TRANSIT = 'transit';
export const LEG_MODE_DRIVE = 'drive';
export const LEG_MODE_CYCLE = 'cycle';
export const LEG_MODE_RAIL = 'rail';

export const HOME_SILO_OUTLINE = 'home-silo-outline';
export const BUS_SCHOOL = 'bus-school';
export const HOME_CIRCLE = 'home-circle';
export const BUS_MULTIPLE = 'bus-multiple';

export const ICONS = {
    [LEG_MODE_RAIL]: mdiTrain,
    [LEG_MODE_WALK]: mdiWalk,
    [LEG_MODE_BUS]: mdiBus,
    [LEG_MODE_TRAM]: mdiTram,
    [LEG_MODE_TRANSIT]: mdiTransitConnection,
    [LEG_MODE_DRIVE]: mdiSteering,
    [LEG_MODE_CYCLE]: mdiBike,
    [HOME_SILO_OUTLINE]: mdiHomeSiloOutline,
    [BUS_SCHOOL]: mdiBusSchool,
    [HOME_CIRCLE]: mdiHomeCircle,
    [BUS_MULTIPLE]: mdiBusMultiple,
    chevronLeft: mdiChevronLeft,
    chevronRight: mdiChevronRight,
    chevronDown: mdiChevronDown,
    alert: mdiAlert,
    iconStar: mdiStar,
    starOutline: mdiStarOutline,
    iconTicket: mdiTicket,
    close: mdiClose,
    directions: mdiDirections,
    magnify: mdiMagnify,
    mapMarker: mdiMapMarker,
    facebook: mdiFacebook,
    twitter: mdiTwitter,
    email: mdiEmail,
    phone: mdiPhone,
    target: mdiTarget,
    mapCircle: {
        path: 'M 0, 0 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0',
        fillColor: '#fff',
        fillOpacity: 1,
        scale: 2.2,
        strokeWeight: 2,
        strokeColor: '#502059',
        text: 'AA',
    },
    mapCircleHighlighted: {
        fillColor: '#502059',
        fillOpacity: 1,
        scale: 2.2,
    }
};
